var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasMessage),expression:"hasMessage"}]},[_c('div',{staticClass:"message align-items-center"},[_c('label',[_vm._v(_vm._s(_vm.alertMessage))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }